export default {
  "en": {
    "activity": {
      "attributes": {
        "end": "End",
        "now": "Now",
        "title": "Activity Feed"
      },
      "labels": {
        "not_opened_yet": "Not seen yet"
      },
      "projects": {
        "announcement": {
          "create": "created a news post."
        },
        "building": {
          "create": "created building <i>'{notifiable_name}'</i>."
        },
        "document": {
          "create": "uploaded document <i>'{notifiable_name}'</i>."
        },
        "lot": {
          "create": "created plot <i>'{notifiable_name}'</i>."
        },
        "phase": {
          "create": "created phase <i>'{notifiable_name}'</i>."
        },
        "published": {
          "customer": "has published decision <i>'{notifiable_name}'</i> for the customer.",
          "partners": "has published decision <i>'{notifiable_name}'</i> for the partner(s)."
        },
        "question": {
          "create": "created question <i>'{notifiable_name}'</i> in FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "create": "created space <i>'{notifiable_name}'</i>.",
          "update": "assigned space <i>'{notifiable_name}'</i> to a unit."
        },
        "survey_type": {
          "create": "created survey of type <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "started conversation <i>'{notifiable_name}'</i>."
        },
        "unit": {
          "assign": "assigned <i>'{notifiable_name}'</i> to a customer.",
          "create": "created unit <i>'{notifiable_name}'</i>.",
          "invisibled": "revoked customer access for <i>'{notifiable_name}'</i>.",
          "unassign": "unassigned <i>'{notifiable_name}'</i> from the customer.",
          "visibled": "gave customer access for <i>'{notifiable_name}'</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "created a news post."
        },
        "decision": {
          "create": "created decision <i>'{notifiable_name}'</i>.",
          "not_interested": "is not interested in decision <i>'{notifiable_name}'</i>.",
          "published": {
            "customer": "has published decision <i>'{notifiable_name}'</i> for the customer.",
            "partners": "has published decision <i>'{notifiable_name}'</i> for the partner(s)."
          },
          "relaunched": "made the decision <i>'{notifiable_name}'</i> available again."
        },
        "decision_document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "approved proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>.",
          "create": {
            "customer": "shared proposal <i>'{notifiable_name}'</i> with customer.",
            "employee": "created proposal <i>'{notifiable_name}'</i>.",
            "partnergroup": "shared proposal <i>'{notifiable_name}'</i> with partner <i>{target_name}</i>."
          },
          "unapproved": "unapproved proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>.",
          "updated": "updated proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>."
        },
        "document": {
          "create": "uploaded document <i>'{notifiable_name}'</i>."
        },
        "proposal": {
          "deleted": "removed proposal <i>'{notifiable_name}'</i>."
        },
        "question": {
          "create": "created question <i>'{notifiable_name}'</i> in FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "update": "assigned space <i>'{notifiable_name}'</i> to this unit."
        },
        "survey": {
          "create": "created survey <i>'{notifiable_name}'</i>.",
          "published": "published survey <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "started conversation <i>'{notifiable_name}'</i>.",
          "message": {
            "move": "moved a message to conversation <i>'{notifiable_name}'</i>."
          }
        },
        "unit": {
          "assign": "assigned <i>'{notifiable_name}'</i> to a customer.",
          "invisibled": "revoked customer access for <i>'{notifiable_name}'</i>.",
          "unassign": "unassigned <i>'{notifiable_name}'</i> from the customer.",
          "visibled": "gave customer access for <i>'{notifiable_name}'</i>."
        }
      }
    }
  }
}